import {EventBase} from "shared/utilities/Events/EventManager";

export class FieldDragStarted extends EventBase{
    ReturnType:FieldDragStarted;
    public static GetName(){
        return 'FieldDragStarted';
    }
}